import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacab() {



  const cardData = {
"keyword": "Pune to Lonavala Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Lonavala Cab service for travelers seeking quick, safe, and affordable weekend travel to the hills. Whether you are planning a short trip, family outing, monsoon getaway, business break, or sightseeing tour, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Lonavala. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and scenic travel experience between Pune and Lonavala via the Mumbai–Pune Expressway.",

"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description":
      "Tiger’s Leap is a famous viewpoint in Lonavala offering breathtaking valley views and a cliff resembling a leaping tiger. Travelers using Pune to Lonavala cab service often visit this scenic spot for photography and nature views."
  },
  {
    "title": "Bhushi Dam",
    "description":
      "Bhushi Dam is one of the most popular attractions in Lonavala known for overflowing water during monsoon and fun water activities. Cab travelers from Pune frequently visit this lively picnic spot."
  },
  {
    "title": "Lion’s Point",
    "description":
      "Lion’s Point is a stunning viewpoint offering panoramic views of valleys and waterfalls. Pune to Lonavala taxi service makes it easy for travelers to enjoy sunrise and sunset views here."
  },
  {
    "title": "Karla Caves",
    "description":
      "Karla Caves are ancient Buddhist rock-cut caves known for historical significance and architectural beauty. Travelers booking Pune to Lonavala cabs often include this heritage site in their itinerary."
  },
  {
    "title": "Lohagad Fort",
    "description":
      "Lohagad Fort is a historic hill fort popular for trekking and scenic views of the Sahyadri mountains. Cab from Pune to Lonavala provides easy access for adventure lovers."
  },
  {
    "title": "Pawna Lake",
    "description":
      "Pawna Lake is a peaceful camping and picnic destination surrounded by hills and water views. Pune to Lonavala cab service is ideal for weekend camping and relaxation trips."
  },
  {
    "title": "Rajmachi Fort",
    "description":
      "Rajmachi Fort is a popular trekking destination offering lush greenery and historical ruins. Travelers from Pune often visit this place for adventure and nature exploration."
  },
  {
    "title": "Sunil’s Celebrity Wax Museum",
    "description":
      "Sunil’s Celebrity Wax Museum features wax statues of famous personalities and is a fun tourist attraction in Lonavala. Taxi from Pune to Lonavala provides convenient access for families."
  },
  {
    "title": "Kune Falls",
    "description":
      "Kune Falls is a beautiful three-tier waterfall located near Lonavala known for its scenic beauty during monsoon. Cab travelers from Pune often stop here for photography and sightseeing."
  },
  {
    "title": "Tungarli Lake",
    "description":
      "Tungarli Lake is a calm and less crowded attraction in Lonavala ideal for peaceful relaxation. Pune to Lonavala cab booking offers easy access for a quiet getaway."
  }
],



services: [
  {
    name: "Pune to Lonavala Cab",
    description: "Pune to Lonavala cab service provides reliable transportation between Pune and Lonavala with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway and hill station travel ensuring smooth and safe journeys for families, tourists, and weekend travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Lonavala Taxi",
    description: "Pune to Lonavala taxi service offers dependable transportation for passengers traveling between Pune and Lonavala with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for tourism, hill station vacations, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Lonavala",
    description: "Cab from Pune to Lonavala service provides comfortable intercity transportation for passengers traveling for tourism, weekend trips, and family vacations. Vehicles ensure reliable expressway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Lonavala. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Lonavala",
    description: "Taxi from Pune to Lonavala service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Lonavala. Vehicles provide smooth highway and hill route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Lonavala Cab Service",
    description: "Pune to Lonavala cab service provides dependable transportation solutions for passengers traveling between Pune and Lonavala with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for hill station travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Ideal for tourism, sightseeing, and weekend trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Lonavala Taxi Fare",
    description: "Pune to Lonavala taxi fare service provides transparent pricing information for passengers planning travel between Pune and Lonavala. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth expressway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Lonavala One Way Cab",
    description: "Pune to Lonavala one way cab service provides economical transportation for passengers traveling from Pune to Lonavala without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for tourism, weekend getaways, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Lonavala including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Lonavala Round Trip Taxi",
    description: "Pune to Lonavala round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Lonavala. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Ideal for tourism, sightseeing, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Lonavala Cab Booking",
    description: "Pune to Lonavala cab booking service allows passengers to reserve comfortable transportation between Pune and Lonavala. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Lonavala Cab",
    description: "Cheap Pune to Lonavala cab service provides affordable transportation between Pune and Lonavala with comfortable vehicles and economical pricing. Vehicles ensure reliable expressway travel suitable for tourism, weekend travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Lonavala. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Lonavala Taxi",
    description: "Best Pune to Lonavala taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth hill station travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Lonavala Cab",
    description: "Sedan Pune to Lonavala cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Lonavala. Sedan vehicles provide smooth expressway travel with comfortable seating and luggage space suitable for short-distance hill station journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Lonavala. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Lonavala Taxi",
    description: "SUV Pune to Lonavala taxi service provides spacious transportation for families and groups traveling between Pune and Lonavala. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for hill station journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Lonavala. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Lonavala Cab",
    description: "Innova Pune to Lonavala cab service provides premium SUV transportation for passengers seeking comfortable and reliable hill station travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Lonavala. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Hill Station Cab Pune Lonavala",
    description: "Hill station cab Pune Lonavala service offers dependable transportation for passengers traveling from Pune to the scenic hill station of Lonavala. Comfortable vehicles ensure smooth expressway and ghat section travel suitable for tourism, monsoon trips, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Lonavala. Flexible booking options allow convenient hill station cab reservations."
  },
  {
    name: "Pune to Khandala Cab",
    description: "Pune to Khandala cab service provides reliable transportation between Pune and Khandala with comfortable vehicles and professional chauffeurs. Vehicles ensure smooth highway and hill route travel suitable for tourism, sightseeing, and weekend trips. Professional drivers ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Khandala. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Lonavala Cab", "Pune to Lonavala Taxi"],
  ["Cab from Pune to Lonavala", "Taxi from Pune to Lonavala"],
  ["Pune to Lonavala Cab Service", "Pune to Lonavala Taxi Fare"],
  ["Pune to Lonavala One Way Cab", "Pune to Lonavala Round Trip Taxi"],
  ["Pune to Lonavala Cab Booking", "Cheap Pune to Lonavala Cab"],
  ["Best Pune to Lonavala Taxi", "Sedan Pune to Lonavala Cab"],
  ["SUV Pune to Lonavala Taxi", "Innova Pune to Lonavala Cab"],
  ["Hill Station Cab Pune Lonavala", "Pune to Khandala Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Lonavala Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Lonavala cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe hill station travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Lonavala Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Lonavala cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Lonavala Cab Service Availability",
        WhyChoosedescription: "Our Pune to Lonavala cab service operates 24 hours a day for weekend trips, family vacations, sightseeing tours, emergency transportation, and business travel."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for passengers visiting Lonavala."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Lonavala taxi service, round-trip bookings, sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ghat Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Lonavala ghat routes and ensure safe driving, smooth travel, and timely arrival for every hill station journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Lonavala cab service?", answer: "Pune to Lonavala cab service provides comfortable taxi transportation between Pune and Lonavala for sightseeing, family trips, and weekend travel." },
    { question: "Is Pune to Lonavala cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Lonavala cab service." },
    { question: "Which vehicles are available for Pune to Lonavala travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Lonavala?", answer: "Yes, customers can book one-way as well as round-trip Pune to Lonavala taxi services." },
    { question: "Do you provide sightseeing cab service in Lonavala?", answer: "Yes, Shivai Travels provides sightseeing cab packages for Lonavala and nearby tourist attractions." },
    { question: "Are all Pune to Lonavala taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Lonavala cab service online?", answer: "Yes, customers can easily book Pune to Lonavala cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Lonavala cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Lonavala cab service?", answer: "Yes, advance booking is available and recommended during weekends, monsoon seasons, and holidays." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rahul Deshmukh",
      feedback:
        "Booked Pune to Lonavala cab service with Shivai Travels. Comfortable car, smooth ghat travel, and professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Sneha Patil",
      feedback:
        "Excellent Pune to Lonavala taxi service. Affordable pricing, clean cab, and wonderful sightseeing experience.",
      rating: 5
    }
  ];






























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-lonavala-cab.jpg",
  "description": "Book Pune to Lonavala cab service for safe and comfortable hill station travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for quick weekend and sightseeing trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-lonavala-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Lonavala Cab Service | Affordable Hill Station Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Lonavala cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for hill station and weekend trips."
  />

  <meta
    name="keywords"
    content="pune to lonavala cab, pune to lonavala taxi, cab from pune to lonavala, taxi from pune to lonavala, pune to lonavala cab service, pune to lonavala taxi fare, pune to lonavala one way cab, pune to lonavala round trip taxi, pune to lonavala cab booking, cheap pune to lonavala cab, best pune to lonavala taxi, sedan pune to lonavala cab, suv pune to lonavala taxi, innova pune to lonavala cab, hill station cab pune lonavala, Pune to Lonavala Cab, Pune to Lonavala Cab Service, Pune to Lonavala Taxi Service, Pune to Lonavala Cab Booking, Best Pune to Lonavala Cab, One Way Pune to Lonavala Cab, Round Trip Pune to Lonavala Taxi, Cheap Pune to Lonavala Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalacab;